module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    ref: "audienceNameForm",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "focus",
      rawName: "v-focus.lazy",
      value: (true),
      expression: "true",
      modifiers: {
        "lazy": true
      }
    }],
    ref: "audienceName",
    class: _vm.textClass,
    attrs: {
      "dark": _vm.attributePanel,
      "outlined": _vm.attributePanel,
      "dense": _vm.dense,
      "name": "audienceName",
      "label": _vm.label,
      "id": "audienceName",
      "autocomplete": "off",
      "disabled": _vm.disabled,
      "error-messages": _vm.errorMessages
    },
    on: {
      "focus": _vm.targetNameFocusHandler,
      "blur": _vm.targetNameOutOfFocusHandler,
      "input": _vm.handleInput
    },
    model: {
      value: (_vm.display_name),
      callback: function($$v) {
        _vm.display_name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "display_name"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07beba6b","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/components/TargetName.vue
// module id = 1985
// module chunks = 0